import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const LeadsForm = () => {
  const [userData, setUserData] = useState(null);
  const [formData, setFormData] = useState({
    propertyListed: "",
    propertyOwner: "",
    ownedYears: "",
    hasMortgage: "",
    livingStatus: "",
    propertyType: "",
    repairsNeeded: [],
    sellingReason: [],
    closingTime: "",
    ownerFirstName: "",
    ownerLastName: "",
    propertyAddress: "",
    phoneNumber: "",
    leadTemplate: "",
    city: "",
    state: "",
    source: "This lead was verified and generated through an actual phone call",
  });
  const apiKey = process.env.REACT_APP_API_KEY;
  const [cities, setCities] = useState([]);
  const auth = getAuth();
  const [loading, setLoading] = useState(true);

  const [uid, setUid] = useState(null);
  const navigate = useNavigate();

  const statesList = [
    { name: "Alabama", abbr: "AL" },
    { name: "Alaska", abbr: "AK" },
    { name: "Arizona", abbr: "AZ" },
    { name: "Arkansas", abbr: "AR" },
    { name: "California", abbr: "CA" },
    { name: "Colorado", abbr: "CO" },
    { name: "Connecticut", abbr: "CT" },
    { name: "Delaware", abbr: "DE" },
    { name: "Florida", abbr: "FL" },
    { name: "Georgia", abbr: "GA" },
    { name: "Hawaii", abbr: "HI" },
    { name: "Idaho", abbr: "ID" },
    { name: "Illinois", abbr: "IL" },
    { name: "Indiana", abbr: "IN" },
    { name: "Iowa", abbr: "IA" },
    { name: "Kansas", abbr: "KS" },
    { name: "Kentucky", abbr: "KY" },
    { name: "Louisiana", abbr: "LA" },
    { name: "Maine", abbr: "ME" },
    { name: "Maryland", abbr: "MD" },
    { name: "Massachusetts", abbr: "MA" },
    { name: "Michigan", abbr: "MI" },
    { name: "Minnesota", abbr: "MN" },
    { name: "Mississippi", abbr: "MS" },
    { name: "Missouri", abbr: "MO" },
    { name: "Montana", abbr: "MT" },
    { name: "Nebraska", abbr: "NE" },
    { name: "Nevada", abbr: "NV" },
    { name: "New Hampshire", abbr: "NH" },
    { name: "New Jersey", abbr: "NJ" },
    { name: "New Mexico", abbr: "NM" },
    { name: "New York", abbr: "NY" },
    { name: "North Carolina", abbr: "NC" },
    { name: "North Dakota", abbr: "ND" },
    { name: "Ohio", abbr: "OH" },
    { name: "Oklahoma", abbr: "OK" },
    { name: "Oregon", abbr: "OR" },
    { name: "Pennsylvania", abbr: "PA" },
    { name: "Rhode Island", abbr: "RI" },
    { name: "South Carolina", abbr: "SC" },
    { name: "South Dakota", abbr: "SD" },
    { name: "Tennessee", abbr: "TN" },
    { name: "Texas", abbr: "TX" },
    { name: "Utah", abbr: "UT" },
    { name: "Vermont", abbr: "VT" },
    { name: "Virginia", abbr: "VA" },
    { name: "Washington", abbr: "WA" },
    { name: "West Virginia", abbr: "WV" },
    { name: "Wisconsin", abbr: "WI" },
    { name: "Wyoming", abbr: "WY" },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked
          ? [...prev[name], value]
          : prev[name].filter((item) => item !== value),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));

      if (name === "state") {
        const selectedState = statesList.find((state) => state.name === value);
        if (selectedState) {
          setFormData((prev) => ({
            ...prev,
            state: selectedState.abbr, // Store full state name
            city: "", // Reset city selection when state changes
          }));
        }
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const key in formData) {
      if (!formData[key]) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Please fill in all fields.",
        });
        return;
      }
    }

    const apiUrl = "https://api.v1.spotyourleads.com/lead/submit";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Form submitted successfully!",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          setFormData({
            propertyListed: "",
            propertyOwner: "",
            ownedYears: "",
            hasMortgage: "",
            livingStatus: "",
            propertyType: "",
            repairsNeeded: [],
            sellingReason: [],
            closingTime: "",
            ownerFirstName: "",
            ownerLastName: "",
            propertyAddress: "",
            phoneNumber: "",
            leadTemplate: "",
            city: "",
            state: "",
          });

          document.querySelectorAll("input[type=radio]").forEach((radio) => {
            radio.checked = false;
          });
          document
            .querySelectorAll("input[type=checkbox]")
            .forEach((checkbox) => {
              checkbox.checked = false;
            });
        });
      } else if (response.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: result?.message || "Bad request. Please check your inputs.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Failed to submit the form. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form.");
    }
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUid(user.uid);
      } else {
        navigate("/sign-in");
      }
    });

    return () => unsubscribe();
  }, [auth, navigate]);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!uid) return;

      try {
        const response = await fetch(
          `https://api.v1.spotyourleads.com/user/${uid}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": apiKey,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }

        const data = await response.json();

        if (!data.isAdmin && !data.isModerator) {
          navigate("/sign-in");
          return;
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error.message);
        navigate("/sign-in");
      }
    };

    if (uid) {
      fetchUserData();
    }
  }, [uid, apiKey, navigate]);

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div class="loader"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Spot Your Leads | Lead Form</title>
      </Helmet>
      <section className="homeFourth formSection account leads-form">
        <Container>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="formDiv">
                <h2>Leads Form</h2>
                <form onSubmit={handleSubmit}>
                  <h3>Is your property listed with a real estate agent?</h3>
                  <label>
                    <input
                      type="radio"
                      name="propertyListed"
                      value="No it's not listed"
                      onChange={handleChange}
                    />
                    <span>No it's not listed</span>
                  </label>
                  <br />
                  <label>
                    <input
                      type="radio"
                      name="propertyListed"
                      value="Yes it's listed"
                      onChange={handleChange}
                    />
                    <span>Yes it's listed</span>
                  </label>

                  <h3>Are you the owner of this property?</h3>
                  <label>
                    <input
                      type="radio"
                      name="propertyOwner"
                      value="Yes, i own this property"
                      onChange={handleChange}
                    />
                    <span>Yes, I own this property</span>
                  </label>
                  <br />
                  <label>
                    <input
                      type="radio"
                      name="propertyOwner"
                      value="Agent/wholesaler/Property Manager"
                      onChange={handleChange}
                    />
                    <span>Agent/Wholesaler/Property Manager</span>
                  </label>

                  <h3>How long have you owned the property in years?</h3>
                  <input
                    type="number"
                    className="form-control"
                    name="ownedYears"
                    value={formData.ownedYears}
                    onChange={handleChange}
                  />

                  <h3>Is there a mortgage on the house?</h3>
                  <label>
                    <input
                      type="radio"
                      name="hasMortgage"
                      value="Yes"
                      onChange={handleChange}
                    />
                    <span>Yes</span>
                  </label>
                  <br />
                  <label>
                    <input
                      type="radio"
                      name="hasMortgage"
                      value="There is no mortgage"
                      onChange={handleChange}
                    />
                    <span>There is no mortgage</span>
                  </label>

                  <h3>Is there anyone living on the property?</h3>
                  <label>
                    <input
                      type="radio"
                      name="livingStatus"
                      value="Vacant"
                      onChange={handleChange}
                    />
                    <span>Vacant</span>
                  </label>
                  <br />
                  <label>
                    <input
                      type="radio"
                      name="livingStatus"
                      value="Tenants Occupied"
                      onChange={handleChange}
                    />
                    <span>Tenants Occupied</span>
                  </label>
                  <br />
                  <label>
                    <input
                      type="radio"
                      name="livingStatus"
                      value="Owner Occupied"
                      onChange={handleChange}
                    />
                    <span>Owner Occupied</span>
                  </label>

                  <h3>Type of the Property</h3>
                  <select
                    name="propertyType"
                    className="form-control"
                    value={formData.propertyType}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      Select a property type
                    </option>
                    <option value="Single family">Single family</option>
                    <option value="Ranch">Ranch</option>
                    <option value="2-story">2-story</option>
                    <option value="Mobile home owned land">
                      Mobile home owned land
                    </option>
                    <option value="Mobile home rented land">
                      Mobile home rented land
                    </option>
                    <option value="Multifamily">Multifamily</option>
                    <option value="Bungalow">Bungalow</option>
                    <option value="Cottage">Cottage</option>
                    <option value="Townhouse">Townhouse</option>
                    <option value="Condominium">Condominium</option>
                    <option value="Duplex">Duplex</option>
                    <option value="Farmhouse">Farmhouse</option>
                    <option value="Split-level home">Split-level home</option>
                    <option value="Land">Land</option>
                    <option value="Commercial Property">
                      Commercial Property
                    </option>
                  </select>
                  <br />
                  <h3>What kind of repairs does the property need?</h3>
                  <Row>
                    {[
                      "It's a brand new home and needs nothing",
                      "Structural Problems",
                      "Flood/storm/fire damage",
                      "Roof Needs Replacement",
                      "Foundation Problems",
                      "Bathroom(s) need work",
                      "Paint Inside",
                      "Boiler/Water Heater",
                      "Landscaping",
                      "Electrical",
                      "Plumbing",
                      "Flooring",
                      "Kitchen Cabinets",
                      "Kitchen Appliances",
                      "Paint Outside",
                      "Air Conditioning",
                      "Windows",
                      "Walls",
                      "Needs a total rehab",
                    ].map((repair) => (
                      <Col md={4} sm={6} key={repair}>
                        <label>
                          <input
                            type="checkbox"
                            name="repairsNeeded"
                            value={repair}
                            onChange={handleChange}
                          />
                          <span>{repair}</span>
                        </label>
                      </Col>
                    ))}
                  </Row>

                  <h3>What would be the reason for selling?</h3>
                  <Row>
                    {[
                      "Preforeclosure",
                      "Emergency Reasons",
                      "Financial Reasons",
                      "Selling a vacant/non-occupied house",
                      "Sell and invest in something else",
                      "Death in the family",
                      "Inherited Property",
                      "Downsizing",
                      "Upsize",
                      "Tired of being a landlord",
                      "Moving closer to family",
                      "Retirement elsewhere",
                      "Moving from United States",
                      "Moving to another state",
                      "Extra property doesn't need it",
                      "Health Issues",
                      " Mortgage Payments",
                      "Elderly",
                      "Moving to a nursing home",
                      "Can’t handle the repairs",
                      "Relocation",
                      "Divorce",
                    ].map((reason) => (
                      <Col md={4} sm={6} key={reason}>
                        <label>
                          <input
                            type="checkbox"
                            name="sellingReason"
                            value={reason}
                            onChange={handleChange}
                          />
                          <span>{reason}</span>
                        </label>
                      </Col>
                    ))}
                  </Row>

                  <h3>How soon are you looking to close?</h3>
                  <select
                    name="closingTime"
                    className="form-control"
                    value={formData.closingTime}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      Select a closing time
                    </option>
                    <option value="ASAP">ASAP</option>
                    <option value="Couple weeks">Couple weeks</option>
                    <option value="1 Month">1 Month</option>
                    <option value="2 Months">2 Months</option>
                    <option value="3 Months">3 Months</option>
                    <option value="4~5 Months">4~5 Months</option>
                    <option value="6 Months">6 Months</option>
                  </select>
                  <br />

                  <h3>Owner First Name</h3>
                  <input
                    className="form-control"
                    type="text"
                    name="ownerFirstName"
                    value={formData.ownerFirstName}
                    onChange={handleChange}
                  />

                  <h3>Owner Last Name</h3>
                  <input
                    className="form-control"
                    type="text"
                    name="ownerLastName"
                    value={formData.ownerLastName}
                    onChange={handleChange}
                  />
                  <h3>Property Address</h3>
                  <input
                    className="form-control"
                    type="text"
                    name="propertyAddress"
                    value={formData.propertyAddress}
                    onChange={handleChange}
                  />
                  <h3>Phone Number</h3>
                  <input
                    type="tel"
                    className="form-control"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                  />

                  <h3>State</h3>
                  <select
                    name="state"
                    className="form-control"
                    value={formData.state}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      {" "}
                      Select a state
                    </option>
                    {statesList?.map((state, index) => (
                      <option key={index} value={state.abbr}>
                        {state.abbr} {/* Ensure value matches state.name */}
                      </option>
                    ))}
                  </select>

                  {formData.state && (
                    <>
                      <h3>City</h3>
                      <input
                        type="text"
                        className="form-control"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </>
                  )}
                  <br />

                  <h3>Lead Template</h3>
                  <ReactQuill
                    theme="snow"
                    value={formData.leadTemplate}
                    onChange={(value) =>
                      setFormData((prev) => ({ ...prev, leadTemplate: value }))
                    }
                  />
                  {/* <textarea
                    className="form-control"
                    name="leadTemplate"
                    value={formData.leadTemplate}
                    onChange={handleChange}
                  /> */}
                  <button type="submit">Save</button>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default LeadsForm;
